class VideoTestimonials extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.video-testimonials__track');
    this.slides = Array.from(this.querySelectorAll('.video-testimonials__slide'));
    this.dots = Array.from(this.querySelectorAll('.video-testimonials__dot'));
    this.images = Array.from(this.querySelectorAll('.video-testimonials__image'));
    this.prevButton = this.querySelector('.video-testimonials__arrow--prev');
    this.nextButton = this.querySelector('.video-testimonials__arrow--next');
    this.index = 0;
    if (!this.track || !this.slides.length) return;

    this.observeImages();

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.goTo(this.index - 1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.goTo(this.index + 1));

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });

    this.querySelectorAll('.video-testimonials__play').forEach((button) => {
      button.addEventListener('click', () => this.play(button));
    });

    this.track.addEventListener(
      'scroll',
      () => {
        this.loadImages();
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.onScroll(), 80);
      },
      { passive: true }
    );

    this.onBlockSelect = (event) => {
      if (!this.contains(event.target)) return;
      const slide = event.target.closest('.video-testimonials__slide');
      if (slide) this.goTo(Number(slide.dataset.index), false);
    };
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    if (this.observer) this.observer.disconnect();
    clearTimeout(this.scrollTimer);
  }

  observeImages() {
    if (!this.images.length) return;
    if (!('IntersectionObserver' in window)) {
      this.loadImages();
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.loadImages();
      },
      { rootMargin: '400px 0px' }
    );
    this.observer.observe(this);
  }

  loadImages() {
    if (this.imagesLoaded) return;
    this.imagesLoaded = true;
    if (this.observer) this.observer.disconnect();
    this.images.forEach((image) => {
      image.loading = 'eager';
      image.decoding = 'async';
    });
  }

  goTo(index, smooth = true) {
    this.loadImages();
    const count = this.slides.length;
    const target = (index + count) % count;
    this.track.scrollTo({
      left: this.slides[target].offsetLeft,
      behavior: smooth ? 'smooth' : 'auto',
    });
    this.setActive(target);
  }

  onScroll() {
    const width = this.track.clientWidth;
    if (!width) return;
    const index = Math.round(this.track.scrollLeft / width);
    if (index !== this.index) this.setActive(index);
  }

  setActive(index) {
    this.index = index;
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
    this.stopOthers(index);
  }

  stopOthers(activeIndex) {
    this.slides.forEach((slide, index) => {
      if (index === activeIndex) return;
      const video = slide.querySelector('video');
      if (video && !video.paused) video.pause();
    });
  }

  play(button) {
    const slide = button.closest('.video-testimonials__slide');
    const video = slide ? slide.querySelector('video') : null;
    if (!video) return;
    video.controls = true;
    slide.classList.add('is-playing');
    video.play().catch(() => {});
  }
}

if (!customElements.get('video-testimonials')) {
  customElements.define('video-testimonials', VideoTestimonials);
}